module.exports = __webpack_public_path__ + "images/84bf849363ce2a7240b97c7101cf275109252b874c1045f890b0cb99158d4143.svg";